import { render, staticRenderFns } from "./updata-param.vue?vue&type=template&id=c1cbb41c"
import script from "./updata-param.vue?vue&type=script&lang=js"
export * from "./updata-param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1cbb41c')) {
      api.createRecord('c1cbb41c', component.options)
    } else {
      api.reload('c1cbb41c', component.options)
    }
    module.hot.accept("./updata-param.vue?vue&type=template&id=c1cbb41c", function () {
      api.rerender('c1cbb41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/updata-param.vue"
export default component.exports